import type { Store } from '../../net/store'
import { isRoomless } from '../flow'
import type { Flow } from '../flow'

/**
 * Try on (PHASE3 T3.9a) lasts while the player stays on the hub and its pages (shop, profile,
 * settings): the first screen with a room (a join from the hub) clears it, so a race and the
 * next visit to the hub show the equipped item again. Returns the unsubscribe.
 */
export function clearTryOnForRaces<T>(flow: Store<Flow>, tryOn: Store<T | null>): () => void {
  return flow.subscribe((f) => {
    if (!isRoomless(f)) tryOn.set(null)
  })
}
